<template>
  <b-card>
    <FormBuilder
      label="Layanan Kurir"
      create
      :fields="fields"
      :loading-submit="$store.state.courierService.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/courier-service'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('courierService/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
